import $http from '@/plugins/axios'
import { UserSearchMode } from '@/utils/enums/user-enums'

const RESOURCE_NAME = '/admin/users'
const CUSTOMER_ROLES_RESOURCE_NAME = '/admin/customer-roles'

export default {
  getUserAddresses (userId) {
    return $http().get(`${RESOURCE_NAME}/${userId}/addresses`)
  },

  updateUserAddress (userId, address) {
    return $http().put(`${RESOURCE_NAME}/${userId}/addresses/${address.userAddressId}`, address)
  },

  createUserAddress (userId, address) {
    return $http().post(`${RESOURCE_NAME}/${userId}/addresses`, address)
  },

  deleteUserAddress (userId, address) {
    return $http().delete(`${RESOURCE_NAME}/${userId}/addresses/${address.userAddressId}`)
  },

  getUserPaymentMethods (userId) {
    return $http().get(`${RESOURCE_NAME}/${userId}/payment-methods`)
  },

  getUserGiftCardPaymentMethods (userId) {
    return $http().get(`${RESOURCE_NAME}/${userId}/payment-methods/gift-cards`)
  },

  getCustomerRoles (userId) {
    return $http().get(`${RESOURCE_NAME}/${userId}/customer-roles/`)
  },

  getCustomerRoleOptions () {
    return $http().get(`${CUSTOMER_ROLES_RESOURCE_NAME}/`)
  },

  createUserPaymentMethod (userId, paymentSourceToken, billingAddress) {
    return $http().post(`${RESOURCE_NAME}/${userId}/payment-methods`, {
      paymentSourceToken,
      billingAddress
    })
  },

  deleteUserPaymentMethod (userId, methodId) {
    return $http().delete(`${RESOURCE_NAME}/${userId}/payment-methods/${methodId}`)
  },

  setDefaultPaymentMethod (userId, methodId) {
    return $http().put(`${RESOURCE_NAME}/${userId}/payment-methods/${methodId}`)
  },

  getUsersPaged (skipCount, maxResultCount, searchTerm, searchMode = UserSearchMode.AllUsers, customerRoleId = null) {
    var params = {
      skipCount,
      maxResultCount,
      searchMode,
      customerRoleId
    }
    if (searchTerm) {
      params.keyword = searchTerm
    }
    return $http().get(`${RESOURCE_NAME}/paged`, { params })
  },

  getUserById (userId) {
    return $http().get(`${RESOURCE_NAME}/${userId}`)
  },

  getUserByEmail (email) {
    return $http().get(`${RESOURCE_NAME}/email/${email}`)
  },

  updateUserInfo (userId, user) {
    return $http().patch(`${RESOURCE_NAME}/${userId}`, user)
  }
}
